import React from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment';

export const BarToPrint = React.forwardRef((props, ref) => {

  const {singleOrder} = useSelector(state=>state.singleOrderDetails)
  const date = new Date(singleOrder?.pickup_at)
  const formatted_time = moment(date).format('h:mma');
  const formatted_date = moment(singleOrder?.pickup_at).format('MMM DD, YYYY');
  const division_totals = singleOrder?.get_divisions.split(',').length
  const total_item_by_division = singleOrder?.total_item_by_division.replace('[','').replace(']', '').split(',')
  const arr_divisions = singleOrder?.get_divisions.replace('[','').replace(']', '').split(',')
  const arr_division_names = singleOrder?.get_division_names.replace('[','').replace(']', '').split(',')
  var divisions = [];

  for(let i = 0; i < division_totals; i++){
    debugger;
    if (arr_division_names[i].replaceAll('"', '').trim() === 'Bar Printer') {
      divisions.push(
        <div key = {i}>
          <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
          <meta name="viewport" content="initial-scale=1.0" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
          <meta name="format-detection" content="telephone=no" />
          <title>Damascus Food Delivery</title>
          <link rel="preconnect" href="https://fonts.googleapis.com" />
          <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
          <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap" rel="stylesheet" />
          <style type="text/css" dangerouslySetInnerHTML={{__html: "\n      html{width:100%;}\n   table {mso-table-lspace:0pt; mso-table-rspace:0pt; border-spacing:0 !important;}\n      table td {border-collapse:collapse; display:table-cell!important;}\n      table p{margin:0;}\n      br, strong br, b br, em br, i br { line-height:100%; }\n      div, p, a, li, td { -webkit-text-size-adjust:none; -ms-text-size-adjust:none;}\n      h1, h2, h3, h4, h5, h6 { line-height: 100% !important; -webkit-font-smoothing: antialiased; }\n      span a ,a { text-decoration: none !important;}\n      img{height: auto !important; line-height: 100%; outline: none; text-decoration: none !important;  -ms-interpolation-mode:bicubic; }\n      /*mailChimp class*/\n      ul{padding-left:10px; margin:0;}\n      table td {border-collapse:collapse; display:table-cell!important;}\n      table,td,img{min-width:0!important;}\n      @media only screen and (max-width:640px){\n      .full-width,.container{width:90%!important; float:none!important; min-width:90%!important; max-width:90%!important; margin:0 auto!important; padding-left:20px; padding-right:20px; text-align: center!important; clear: both;}\n      #mainStructure, #mainStructure .full-width .full-width,table .full-width .full-width, .container .full-width{width:100%!important; float:none!important; min-width:100%!important; max-width:100%!important; margin:0 auto!important; clear: both; padding-left:0; padding-right:0;}\n      .no-pad{padding:0!important;}\n      .full-block{display:block!important;}\n      .full-width.fix-800{min-width:auto!important;}\n      .remove-block{display:none !important;}\n      .pad-lr-20{padding-left:20px!important; padding-right:20px!important;}\n      }\n      @media only screen and (max-width:480px){\n      .full-width,.container{width:90%!important; float:none!important; min-width:90%!important; max-width:90%!important; margin:0 auto!important; padding-left:20px; padding-right:20px; text-align: center!important; clear: both;}\n      #mainStructure, #mainStructure .full-width .full-width,table .full-width .full-width,.container .full-width{width:100%!important; float:none!important; min-width:100%!important; max-width:100%!important; margin:0 auto!important; clear: both; padding-left:0; padding-right:0;}\n      .no-pad{padding:0!important;}\n      .full-block{display:block!important;}\n      .full-width.fix-800{min-width:auto!important;}\n      .remove-block{display:none !important;}\n      .pad-lr-20{padding-left:20px!important; padding-right:20px!important;}\n      }\n    " }} />
          <table id="mainStructure" className="full-width" width={400} align="center" border={0} cellSpacing={0} cellPadding={0} style={{fontFamily: '"Roboto", sans-serif', backgroundColor: '#ffffff', maxWidth: '400px', margin: '0px auto', boxShadow: 'rgb(224, 224, 224) 0px 0px 30px 5px', padding: '40px'}} bgcolor="#ffffff">
            {/*START LAYOUT-3 ( SET-6 )*/}
            <tbody>
              <tr>
                <td align="center" valign="top" bgcolor="#ffffff">
                  <table width={400} align="center" border={0} cellSpacing={0} cellPadding={0} className="full-width  no-pad" style={{backgroundColor: '#FFFFFF', width: '100%'}} bgcolor="#FFFFFF">
                    <tbody><tr>
                        <td valign="top">
                          <table width={400} border={0} cellSpacing={0} cellPadding={0} align="center" className="full-width" style={{width: '100%', margin: '0px auto'}}>
                            <tbody>
                              <tr dup={0}>
                                <td valign="top" align="center" height={60} style={{}} />
                              </tr>
                              <tr dup={0}>
                                <td valign="top" align="center" style={{fontWeight: 700, fontSize: '48px', lineHeight: '155%'}}>DAMASCUS</td>
                              </tr>
                              <tr dup={0}>
                                <td valign="top" align="center" height={10} style={{}} />
                              </tr>
                              <tr dup={0}>
                                <td valign="top" align="center" style={{fontWeight: 500, fontSize: '45px', lineHeight: '49px'}}>{singleOrder?.id}</td>
                              </tr>
                              <tr dup={0}>
                                <td valign="top" align="center" height={10} style={{}} />
                              </tr>
                              <tr dup={0}>
                                <td valign="top" align="center" style={{fontWeight: 700, fontSize: '18px', lineHeight: '155%'}}>{total_item_by_division[i]} items for {singleOrder?.user?.full_name}</td>
                              </tr>
                              <tr dup={0}>
                                <td valign="top" align="center" height={15} style={{}} />
                              </tr>
                              <tr dup={0}>
                                <td valign="top" align="center" height={4} style={{backgroundColor: '#000000'}} />
                              </tr>
                              <tr dup={0}>
                                <td valign="top" align="center" height={15} style={{}} />
                              </tr>
                              <tr dup={0}>
                                <td valign="top" align="center" height={6} style={{}} />
                              </tr>
                              <tr dup={0}>
                                <td valign="top" align="center" style={{fontWeight: 500, fontSize: '35px', lineHeight: '49px'}}>{arr_division_names[i].replaceAll('"', '')}</td>
                              </tr>
                              <tr dup={0}>
                                <td valign="top" align="center" height={15} style={{}} />
                              </tr>
                              <tr dup={0}>
                                <td valign="top" align="center" height={4} style={{backgroundColor: '#000000'}} />
                              </tr>
                              <tr dup={0}>
                                <td valign="top" align="center" height={15} style={{}} />
                              </tr>
                              <tr dup={0}>
                                <td valign="top" align="center" height={6} style={{}} />
                              </tr>
                              <tr dup={0}>
                                <td valign="top" align="left" style={{fontWeight: 400, fontSize: '18px', lineHeight: '155%'}}>Ordered at {formatted_time}, {formatted_date}</td>
                              </tr>
                              <tr dup={0}>
                                <td valign="top" align="center" height={5} style={{}} />
                              </tr>
                              
                              <tr dup={0}>
                                <td valign="top" align="center" height={15} style={{}} />
                              </tr>
                              <tr dup={0}>
                                <td valign="top" align="center" height={4} style={{backgroundColor: '#000000'}} />
                              </tr>
                              <tr dup={0}>
                                <td valign="top" align="center" height={15} style={{}} />
                              </tr>
                              {singleOrder?.order_products.map((prod) => (
                                <div key={prod.id}>
                                <tr dup={0}>
                                {prod?.get_division_id == arr_divisions[i]  ? (
                                  <td valign="top" align="center">
                                    <table align="center" border={0} cellSpacing={0} cellPadding={0} className="full-width  no-pad" style={{backgroundColor: '#FFFFFF', width: '100%', borderBottom: '2px dashed #000000'}} bgcolor="#FFFFFF">
                                      <tbody>
                                       <tr dup={0}>
                                          <td valign="top" align="center" height={6} style={{}} />
                                        </tr>
                                        <tr dup={0}>
                                          <td valign="top" align="left" style={{fontWeight: 'bold', fontSize: '18px', lineHeight: '155%'}}>{prod.quantity} x {prod.name}</td>
                                        </tr>
                                        <tr dup={0}>
                                          <td valign="top" align="center" height={6} style={{}} />
                                        </tr>
                                        {prod?.addons !="" ?
                                        <tr dup={0}>
                                          <td valign="top" align="left" style={{fontWeight: 500, fontSize: '15px', lineHeight: '155%', paddingLeft: '30px'}}>Add on for {prod.name}</td>
                                        </tr> : null
                                        }
                                        {prod?.addons?.map((AddOns) =>(
                                        <div key={AddOns.id}>
                                        <tr dup={0}>
                                          <td valign="top" align="left" style={{fontWeight: 400, fontSize: '15px', lineHeight: '155%', paddingLeft: '40px'}}>{AddOns?.quantity} x {AddOns?.name}</td>
                                          <td valign="top" align="right" style={{fontWeight: 400, fontSize: '15px', lineHeight: '155%'}}>{AddOns?.price}</td>
                                        </tr>
                                        </div>
                                        ))}
                                        <tr dup={0}>
                                          <td valign="top" align="center" height={6} style={{}} />
                                        </tr>
                                
                                        <tr dup={0}>
                                          <td valign="top" align="center" height={3} style={{}} />
                                        </tr>
                                        {prod.modificators.map((modific) =>(<>
                                        <div key={modific.id}>
                                        <tr dup={0}>
                                          <td valign="top" align="left" style={{fontWeight: 500, fontSize: '15px', lineHeight: '155%', paddingLeft: '30px'}}>{modific?.group?.name}</td>
                                        </tr>
                                        <tr dup={0}>
                                          <td valign="top" align="center" height={2} style={{}} />
                                        </tr>
                                        <tr dup={0}>
                                          <td valign="top" align="left" style={{fontWeight: 400, fontSize: '15px', lineHeight: '155%', paddingLeft: '40px'}}>{modific?.group_item?.name}</td>
                                          <td valign="top" align="right" style={{fontWeight: 400, fontSize: '15px', lineHeight: '155%'}}>{modific?.group_item?.price}</td>
                                        </tr>
                                          <tr dup={0}>
                                          <td valign="top" align="center" height={6} style={{}} />
                                        </tr>
                                        </div>
                                        </>))}
                                        <tr dup={0}>
                                          <td valign="top" align="center" style={{fontWeight: 700, fontSize: '24px', lineHeight: '155%', padding: '0 30px', textAlign: 'left'}}>{prod.note}</td>
                                        </tr>
                                        <tr dup={0}>
                                          <td valign="top" align="center" height={15} style={{}} />
                                        </tr>
                                      </tbody></table>
                                  </td>
                                ):null}
                                </tr>
                                </div>
                              ))}
      
                              <tr dup={0}>
                                <td valign="top" align="center" height={4} style={{backgroundColor: '#000000'}} />
                              </tr>
                              <tr dup={0}>
                                <td valign="top" align="center" height={15} style={{}} />
                              </tr>
                             {/* <tr dup={0}>
                                <td valign="top" align="center" style={{fontWeight: 400, fontSize: '15px', lineHeight: '155%'}}>Thank you. {singleOrder?.user?.full_name} for order from</td>
                              </tr>
                              <tr dup={0}>
                                <td valign="top" align="center" height={10} style={{}} />
                              </tr>
                              <tr dup={0}>
                                <td valign="top" align="center" style={{fontWeight: 700, fontSize: '15px', lineHeight: '155%'}}>Damascus Food Delivery App</td>
                              </tr>*/}
                              <tr dup={0}>
                                <td valign="top" align="center" height={60} style={{}} />
                              </tr>
                            </tbody>
                           </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )
    }
  }
   
  return (
    <div ref={ref}>
      {divisions} 
    </div>
  );
});